import { useEnableStockAudit } from '../feature-flags/hooks/use-enable-stock-audit';
import { useStockAuditsFeatureGate } from './use-stock-audits-feature-gate';

export const useIsStockAuditsAvailable = () => {
  const isFlagEnabled = useEnableStockAudit();
  const { isFeatureEnabled: isPlanEnabled } = useStockAuditsFeatureGate();

  return {
    isAvailable: isFlagEnabled && isPlanEnabled,
    isFlagEnabled,
  };
};
